import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import ButtonGrid from "./ButtonGrid.js";

export default function Dialog (props)
{
    const cancelTitle = props.cancelTitle === undefined ? "Annuler" : props.cancelTitle;
    const confirmTitle = props.confirmTitle === undefined ? "Confirmer" : props.confirmTitle;

    const cancel = props.cancel === undefined ? props.hide : props.cancel;
    const confirm = props.confirm === undefined ? props.hide : props.confirm;
    
    return (
	<Modal
	    show={props.show}
	    onHide={props.hide}
	>
	    <Modal.Header> {/* closeButton */}
		<Modal.Title>{props.title}</Modal.Title>
	    </Modal.Header>

	    <Modal.Body>{props.children}</Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={() => { props.hide(); cancel(); }}>{cancelTitle}</Button>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			{props.confirm !== undefined && (<Button variant="primary" size="md" onClick={() => { props.hide(); confirm(); }}>{confirmTitle}</Button>)}
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
